var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$laravel.user.impersonating)?_c('a',{staticClass:"d-menu-top is-primary",attrs:{"type":"button","href":_vm.$laravel.route('impersonate.leave')}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('return_to_admin')))])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-logout"})])
}]

export { render, staticRenderFns }